import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, of} from 'rxjs';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {catchError} from 'rxjs/operators';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {DxFunnelModule, DxSankeyModule, DxTabPanelModule, DxTabsModule} from 'devextreme-angular';
import {JsonEditorComponent} from '../../../../../../@shared/_generalTools/json-editor/json-editor.component';
import {MatTabsModule} from '@angular/material/tabs';
import {TabAllModule} from '@syncfusion/ej2-angular-navigations';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {EmailStatusDetailsService} from '@app/components/projects/eMailCampaigns/e-mails-batch-list/email-status-details/email-status-details.service';
import {EmailStatusDetailsComponent} from '@app/components/projects/eMailCampaigns/e-mails-batch-list/email-status-details/email-status-details.component';
import {environment} from "@environments/environment";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";

export class ItemInfo {
  argument: string;
  value: number;
}

interface IResults {
  statusCounts: {
    failed: number;
    permanent_fail: number;
    temporary_fail: number;
    delivered: number;
    unknown: number;
    clicked: number;
    opened: number;
    mailgunCreate: number;
    complained: number;
  };
  total: number;
  distinctStatuses: [];
}

const defaultResult: IResults = {
  distinctStatuses: [],
  total: 0,
  statusCounts: {
    failed: 0,
    permanent_fail: 0,
    temporary_fail: 0,
    delivered: 0,
    unknown: 0,
    clicked: 0,
    opened: 0,
    mailgunCreate: 0,
    complained: 0,
  },
};

@Component({
    selector: 'app-mail-elastic-stat',
    imports: [CommonModule, MatProgressSpinnerModule, DxSankeyModule, DxFunnelModule, JsonEditorComponent, MatTabsModule,
        DxTabsModule, DxTabPanelModule, TabAllModule, MatButtonModule, MatIconModule, EmailStatusDetailsComponent],
    templateUrl: './mail-elastic-stat.component.html',
    styleUrls: ['./mail-elastic-stat.component.scss']
})
export class MailElasticStatComponent extends OnDestroyMixin implements OnInit {

  // public headerText: Object = [{text: 'Twitter', iconCss: 'e-twitter'},
  //   {text: 'Facebook', iconCss: 'e-facebook'}, {text: 'WhatsApp', iconCss: 'e-whatsapp'}];

  private BASE_URL = environment.apiUrl;
  private baseCollection = environment.firestoreReferencesCollection;

  @Input() campaignUuid: string;
  @Input() waveUuid: string;

  isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isGettingQuery$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  results$: BehaviorSubject<IResults> = new BehaviorSubject<IResults>(defaultResult);
  datas$: BehaviorSubject<ItemInfo[]> = new BehaviorSubject<ItemInfo[]>([]);

  constructor(
    private http: HttpClient,
    private afs: AngularFirestore,
    private emailStatusDetailsService: EmailStatusDetailsService,
  ) {
    super();
    this.buildDatas(defaultResult);
  }

  public getWaveStat(forceRefresh = false) {

    if (this.isLoading$.value) {
      return;
    }

    this.isLoading$.next(true);
    const url = `${this.BASE_URL}/publications/emailCampaignActions`;
    return this.http.post<any>(url, {
      // action: 'migrateEmailLogs',
      action: 'getWaveStat',
      params: {
        campaignUuid: this.campaignUuid,
        waveUuid: this.waveUuid,
        forceRefresh,
      }
    }).subscribe({
      next: response => {
        // console.log(response.data.datas.output);
        // this.results$.next(response.data.datas.output);
        this.isLoading$.next(false);
      },
      error: err => {
        console.log(`[Error] testElasticCnx ->`, err);
      },
    });

  }

  ngOnInit(): void {

    this.afs.doc(`${this.baseCollection}/emailStats/${this.campaignUuid}/${this.waveUuid}`)
      .valueChanges()
      .pipe(
        untilComponentDestroyed(this),
        catchError(error => {
          console.log('Error checking document:', error);
          return of(false); // En cas d'erreur, renvoie false.
        })
      )
      .subscribe(
        (data: any) => {

          this.results$.next({
            ...defaultResult,
            ...data,
          });

          const result = this.results$.value;
          // console.log(result);
          this.buildDatas(result);

          // console.log(data);

        });

    this.getWaveStat();

  }

  buildDatas(result) {

    // console.log(result);

    // const data: itemInfo[] = [
    //   { argument: 'Visited the Website', value: 9152 },
    //   { argument: 'Downloaded a Trial', value: 6879 },
    //   { argument: 'Contacted Support', value: 5121 },
    //   { argument: 'Subscribed', value: 2224 },
    //   { argument: 'Renewed', value: 1670 },
    // ];

    //   "delivered": 6490,

    // "permanent_fail": 0,
    //   "temporary_fail": 0,

    //   "opened": 2354,

    //   "complained": 0,

    //   "clicked": 437

    //   "_id": null,
    //   "accepted": 0,
    //   "unsubscribed": 0,


    this.datas$.next([
      {argument: 'Total', value: result.total},
      {argument: 'Delivered', value: result.statusCounts.delivered},
      {argument: 'opened', value: result.statusCounts.opened},
      {argument: 'clicked', value: result.statusCounts.clicked},
    ]);

  }

  customizeText(arg: any) {
    return `<span style='font-size: 28px'>${arg.item.value}</span><br/>${arg.item.argument} (${arg.percentText})`;
  }

  customizeLinkTooltip(info: any) {
    return {
      html: `<b>From:</b> ${info.source}<br/><b>To:</b> ${info.target}<br/><b>Weight:</b> ${info.weight}`,
    };
  }

  displayNotDelivered() {

    // this.waveStatusDetailsWithQuery({'status.delivered': {'$ne': true}});
    this.emailStatusDetailsService.displayNotDelivered(this.campaignUuid, this.waveUuid);

  }

  forceRefresh() {
    this.getWaveStat(true);
  }

  displayFailed() {
    this.emailStatusDetailsService.displayFailed(this.campaignUuid, this.waveUuid);
  }
}
